import React from 'react';
import NotificationPopover from './notification-popover';
import FrenchSystemCheck from './french-system-check';

const Notification = () => {
    return (
        <FrenchSystemCheck>
            <div className='fixed bottom-[38px] right-[62px]'>
                <NotificationPopover />
            </div>
        </FrenchSystemCheck>
    );
};

export default Notification;